class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-mobile-menu-trigger]');
    this.shell = this.querySelector('[data-mobile-menu-shell]');
    this.drawer = this.querySelector('.pp-mobile-menu__drawer');
    this.closeButtons = this.querySelectorAll('[data-mobile-menu-close]');
    this.primaryLinks = this.querySelectorAll('[data-mobile-menu-primary-link]');
    this.handleTriggerClick = this.open.bind(this);
    this.handleKeyup = this.onKeyup.bind(this);
    this.handleClose = this.close.bind(this);
    this.handlePrimaryLinkClick = (event) => event.stopPropagation();
  }

  connectedCallback() {
    // The header uses backdrop-filter, which creates a containing block for fixed
    // descendants. Mount beside the cart drawer so the shell fills the viewport.
    if (this.shell && this.shell.parentElement !== document.body) {
      document.body.appendChild(this.shell);
    }

    this.trigger?.addEventListener('click', this.handleTriggerClick);
    this.closeButtons.forEach((button) => button.addEventListener('click', this.handleClose));
    this.primaryLinks.forEach((link) => link.addEventListener('click', this.handlePrimaryLinkClick));
    document.addEventListener('keyup', this.handleKeyup);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.handleTriggerClick);
    this.closeButtons.forEach((button) => button.removeEventListener('click', this.handleClose));
    this.primaryLinks.forEach((link) => link.removeEventListener('click', this.handlePrimaryLinkClick));
    document.removeEventListener('keyup', this.handleKeyup);
    this.setScrollLock(false);
    this.shell?.remove();
  }

  open() {
    if (!this.shell || !this.drawer || window.matchMedia('(min-width: 990px)').matches) return;

    this.trigger?.setAttribute('aria-expanded', 'true');
    this.setScrollLock(true);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.shell.classList.add('animate', 'active');
        trapFocus(this.drawer, this.drawer.querySelector('.pp-mobile-menu__close') || this.drawer);
      });
    });
  }

  close() {
    if (!this.shell?.classList.contains('active')) return;

    this.shell.classList.remove('active');
    this.trigger?.setAttribute('aria-expanded', 'false');
    removeTrapFocus();
    this.setScrollLock(false);

    try {
      this.trigger?.focus({ preventScroll: true });
    } catch (error) {}
  }

  onKeyup(event) {
    if (event.code === 'Escape' && this.shell?.classList.contains('active')) this.close();
  }

  setScrollLock(shouldLock) {
    if (typeof window.__ppSetPageScrollLock === 'function') {
      window.__ppSetPageScrollLock('mobile-menu-drawer', shouldLock);
      return;
    }

    document.documentElement.classList.toggle('pp-scroll-locked', shouldLock);
    document.body.classList.toggle('pp-scroll-locked', shouldLock);
  }
}

if (!customElements.get('mobile-menu-drawer')) {
  customElements.define('mobile-menu-drawer', MobileMenuDrawer);
}
